module.exports = __webpack_public_path__ + "static/media/nauka-pisania-na-klawiaturze-inf3-2.e98b2614.png";